import React from "react";
import { useDispatch } from "react-redux";
import { addNewProduct } from "../../../Redux/AddProducts/Actions";

const AddProducts = () => {

  const dispatch = useDispatch();

  const handleAddProduct = (e) =>{
    e.preventDefault();
    const form = e.target;
    const product = {
      productName: form.name.value,
      category: form.category.value,
      img: form.imgUrl.value,
      price: parseInt(form.price.value),
      initialQty: parseInt(form.quantity.value) 
    }
    dispatch(addNewProduct(product))
    e.target.reset();
  }

  return (
    <>
      <div>
        {/* <!-- Product Input Form --> */}
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form onSubmit={handleAddProduct} className="space-y-4 text-[#534F4F]" id="lws-addProductForm">
            {/* <!-- product name --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputName">Product Name</label>
              <input
                name="name"
                className="addProductInput"
                id="lws-inputName"
                type="text"
                required
              />
            </div>
            {/* <!-- product category --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputCategory">Category</label>
              <input
                name="category"
                className="addProductInput"
                id="lws-inputCategory"
                type="text"
                required
              />
            </div>
            {/* <!-- product image url --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputImage">Image Url</label>
              <input
                name="imgUrl"
                className="addProductInput"
                id="lws-inputImage"
                type="text"
                required
              />
            </div>
            {/* <!-- price & quantity container --> */}
            <div className="grid grid-cols-2 gap-8 pb-4">
              {/* <!-- price --> */}
              <div className="space-y-2">
                <label htmlFor="ws-inputPrice">Price</label>
                <input
                  name="price"
                  className="addProductInput"
                  type="number"
                  id="lws-inputPrice"
                  required
                />
              </div>
              {/* <!-- quantity --> */}
              <div className="space-y-2">
                <label htmlFor="lws-inputQuantity">Quantity</label>
                <input
                  name="quantity"
                  className="addProductInput"
                  type="number"
                  id="lws-inputQuantity"
                  required
                />
              </div>
            </div>
            {/* <!-- submit button --> */}
            <button type="submit" id="lws-inputSubmit" className="submit">
              Add Product
            </button>
          </form>
        </div>
        {/* <!-- Product Input Form Ends --> */}
      </div>
    </>
  );
};

export default AddProducts;
